/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Author: 3DHaupt (https://sketchfab.com/dennish2010)
License: CC-BY-NC-4.0 (http://creativecommons.org/licenses/by-nc/4.0/)
Source: https://sketchfab.com/3d-models/bullet-physics-animation-9-reconstruction-ed7088cb742a43e18aeb73dac4508c75
Title: Bullet Physics Animation 9 Reconstruction
*/

import React, { useEffect, useRef } from "react";
import { useGLTF, useAnimations } from "@react-three/drei";
import scene from '../assets/3d/bullet.glb'

const Bullet=({currentAnimation,...props})=> {
  const group = useRef();
  const { nodes, materials, animations } = useGLTF(scene);
  const { actions } = useAnimations(animations, group);

  useEffect(() => {
    Object.values(actions).forEach((action)=> action.stop());
    if (actions[currentAnimation]) {
        actions[currentAnimation].play();
    }
    return () => {
      
    }
  }, [actions,currentAnimation])
  

  return (
    <group ref={group} {...props} dispose={null}>
      <group name="Sketchfab_Scene">
        <group
          name="Sketchfab_model"
          rotation={[-Math.PI / 2, 0, 0]}
          scale={0.067}
        >
          <group
            name="Bullet_Physics_Animation_14_Reconstructionfbx"
            rotation={[Math.PI / 2, 0, 0]}
          >
            <group name="Object_2">
              <group name="RootNode">
                <group name="Plane" rotation={[-Math.PI / 2, 0, 0]}>
                  <mesh
                    name="Plane_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Plane_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_906"
                  position={[4, 39.52, 7.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_906_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_906_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_905"
                  position={[4, 47.52, 7.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_905_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_905_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_904"
                  position={[4, 55.52, 7.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_904_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_904_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_903"
                  position={[4, 63.52, 7.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_903_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_903_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_902"
                  position={[2, 63.52, 7.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_902_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_902_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_901"
                  position={[2, 55.52, 7.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_901_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_901_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_900"
                  position={[2, 47.52, 7.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_900_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_900_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_899"
                  position={[2, 39.52, 7.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_899_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_899_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_898"
                  position={[-2, 39.52, 7.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_898_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_898_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_897"
                  position={[-2, 47.52, 7.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_897_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_897_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_896"
                  position={[-2, 55.52, 7.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_896_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_896_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_895"
                  position={[-2, 63.52, 7.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_895_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_895_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_894"
                  position={[0, 63.52, 7.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_894_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_894_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_893"
                  position={[0, 65.52, 7.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_893_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_893_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_892"
                  position={[0, 59.52, 7.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_892_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_892_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_891"
                  position={[0, 55.52, 7.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_891_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_891_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_890"
                  position={[0, 47.52, 7.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_890_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_890_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_889"
                  position={[0, 51.52, 7.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_889_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_889_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_888"
                  position={[0, 43.52, 7.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_888_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_888_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_887"
                  position={[0, 39.52, 7.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_887_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_887_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_886"
                  position={[-4, 63.52, 7.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_886_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_886_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_885"
                  position={[-4, 55.52, 7.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_885_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_885_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_884"
                  position={[0, 45.52, 7.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_884_Material_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_884_Material_0.geometry}
                    material={materials.Material}
                  />
                </group>
                <group
                  name="Cube_883"
                  position={[-4, 47.52, 7.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_883_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_883_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_882"
                  position={[-4, 39.52, 7.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_882_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_882_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_881"
                  position={[0, 53.52, 7.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_881_Material_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_881_Material_0.geometry}
                    material={materials.Material}
                  />
                </group>
                <group
                  name="Cube_880"
                  position={[0, 37.52, 7.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_880_Material_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_880_Material_0.geometry}
                    material={materials.Material}
                  />
                </group>
                <group
                  name="Cube_879"
                  position={[0, 61.52, 7.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_879_Material_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_879_Material_0.geometry}
                    material={materials.Material}
                  />
                </group>
                <group
                  name="Cube_878"
                  position={[-6, 39.52, -4.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_878_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_878_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_877"
                  position={[-6, 47.52, -4.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_877_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_877_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_876"
                  position={[-6, 55.52, -4.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_876_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_876_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_875"
                  position={[-6, 65.52, -4.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_875_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_875_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_874"
                  position={[-6, 63.52, -4.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_874_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_874_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_873"
                  position={[-6, 39.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_873_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_873_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_872"
                  position={[-6, 43.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_872_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_872_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_871"
                  position={[-6, 51.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_871_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_871_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_870"
                  position={[-6, 47.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_870_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_870_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_869"
                  position={[-6, 55.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_869_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_869_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_868"
                  position={[-6, 59.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_868_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_868_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_867"
                  position={[-6, 67.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_867_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_867_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_866"
                  position={[-6, 63.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_866_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_866_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_865"
                  position={[-6, 63.52, -2.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_865_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_865_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_864"
                  position={[-6, 59.52, -2.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_864_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_864_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_863"
                  position={[-6, 55.52, -2.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_863_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_863_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_862"
                  position={[-6, 47.52, -2.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_862_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_862_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_861"
                  position={[-6, 51.52, -2.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_861_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_861_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_860"
                  position={[-6, 43.52, -2.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_860_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_860_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_859"
                  position={[-6, 39.52, -2.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_859_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_859_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_858"
                  position={[-6, 39.52, 1.982]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_858_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_858_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_857"
                  position={[-6, 43.52, 1.982]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_857_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_857_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_856"
                  position={[-6, 51.52, 1.982]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_856_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_856_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_855"
                  position={[-6, 47.52, 1.982]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_855_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_855_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_854"
                  position={[-6, 55.52, 1.982]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_854_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_854_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_853"
                  position={[-6, 59.52, 1.982]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_853_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_853_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_852"
                  position={[-6, 63.52, 1.982]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_852_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_852_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_851"
                  position={[-6, 63.52, 3.982]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_851_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_851_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_850"
                  position={[-6, 65.52, 3.982]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_850_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_850_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_849"
                  position={[-6, 55.52, 3.982]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_849_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_849_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_848"
                  position={[-6, 47.52, 3.982]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_848_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_848_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_847"
                  position={[-6, 39.52, 3.982]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_847_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_847_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_846"
                  position={[6, 39.52, 3.982]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_846_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_846_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_845"
                  position={[6, 47.52, 3.982]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_845_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_845_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_844"
                  position={[6, 55.52, 3.982]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_844_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_844_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_843"
                  position={[6, 65.52, 3.982]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_843_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_843_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_842"
                  position={[6, 63.52, 3.982]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_842_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_842_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_841"
                  position={[6, 63.52, 1.982]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_841_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_841_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_840"
                  position={[6, 59.52, 1.982]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_840_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_840_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_839"
                  position={[6, 55.52, 1.982]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_839_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_839_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_838"
                  position={[6, 47.52, 1.982]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_838_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_838_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_837"
                  position={[6, 51.52, 1.982]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_837_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_837_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_836"
                  position={[6, 43.52, 1.982]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_836_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_836_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_835"
                  position={[6, 39.52, 1.982]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_835_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_835_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_834"
                  position={[6, 39.52, -2.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_834_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_834_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_833"
                  position={[6, 43.52, -2.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_833_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_833_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_832"
                  position={[6, 51.52, -2.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_832_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_832_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_831"
                  position={[6, 47.52, -2.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_831_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_831_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_830"
                  position={[6, 55.52, -2.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_830_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_830_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_829"
                  position={[6, 59.52, -2.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_829_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_829_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_828"
                  position={[6, 63.52, -2.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_828_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_828_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_827"
                  position={[6, 63.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_827_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_827_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_826"
                  position={[6, 67.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_826_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_826_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_825"
                  position={[6, 59.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_825_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_825_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_824"
                  position={[6, 55.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_824_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_824_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_823"
                  position={[6, 47.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_823_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_823_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_822"
                  position={[6, 51.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_822_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_822_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_821"
                  position={[6, 43.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_821_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_821_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_820"
                  position={[6, 39.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_820_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_820_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_819"
                  position={[6, 63.52, -4.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_819_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_819_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_818"
                  position={[6, 67.52, -3.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_818_Material_007_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_818_Material_007_0.geometry}
                    material={materials.Material_007}
                  />
                </group>
                <group
                  name="Cube_817"
                  position={[6, 65.52, -4.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_817_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_817_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_816"
                  position={[6, 55.52, -4.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_816_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_816_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_815"
                  position={[6, 47.52, -4.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_815_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_815_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_814"
                  position={[6, 39.52, -4.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_814_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_814_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_813"
                  position={[0, 61.52, -8.018]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_813_Material_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_813_Material_0.geometry}
                    material={materials.Material}
                  />
                </group>
                <group
                  name="Cube_812"
                  position={[0, 37.52, -8.018]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_812_Material_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_812_Material_0.geometry}
                    material={materials.Material}
                  />
                </group>
                <group
                  name="Cube_811"
                  position={[0, 53.52, -8.018]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_811_Material_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_811_Material_0.geometry}
                    material={materials.Material}
                  />
                </group>
                <group
                  name="Cube_810"
                  position={[-4, 39.52, -8.018]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_810_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_810_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_809"
                  position={[-4, 47.52, -8.018]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_809_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_809_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_808"
                  position={[0, 45.52, -8.018]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_808_Material_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_808_Material_0.geometry}
                    material={materials.Material}
                  />
                </group>
                <group
                  name="Cube_807"
                  position={[-4, 55.52, -8.018]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_807_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_807_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_806"
                  position={[-4, 63.52, -8.018]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_806_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_806_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_805"
                  position={[0, 39.52, -8.018]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_805_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_805_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_804"
                  position={[0, 43.52, -8.018]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_804_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_804_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_803"
                  position={[0, 51.52, -8.018]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_803_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_803_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_802"
                  position={[0, 47.52, -8.018]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_802_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_802_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_801"
                  position={[0, 55.52, -8.018]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_801_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_801_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_800"
                  position={[0, 59.52, -8.018]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_800_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_800_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_799"
                  position={[0, 65.52, -8.018]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_799_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_799_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_798"
                  position={[0, 63.52, -8.018]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_798_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_798_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_797"
                  position={[-2, 63.52, -8.018]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_797_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_797_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_796"
                  position={[-2, 55.52, -8.018]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_796_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_796_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_795"
                  position={[-2, 47.52, -8.018]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_795_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_795_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_794"
                  position={[-2, 39.52, -8.018]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_794_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_794_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_793"
                  position={[2, 39.52, -8.018]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_793_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_793_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_792"
                  position={[2, 47.52, -8.018]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_792_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_792_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_791"
                  position={[2, 55.52, -8.018]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_791_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_791_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_790"
                  position={[2, 63.52, -8.018]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_790_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_790_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_789"
                  position={[4, 63.52, -8.018]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_789_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_789_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_788"
                  position={[4, 55.52, -8.018]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_788_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_788_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_787"
                  position={[4, 47.52, -8.018]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_787_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_787_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_786"
                  position={[4, 39.52, -8.018]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_786_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_786_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_785"
                  position={[0, 61.52, 3.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_785_Material_001_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_785_Material_001_0.geometry}
                    material={materials.Material_001}
                  />
                </group>
                <group
                  name="Cube_784"
                  position={[0, 61.52, -4.018]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_784_Material_001_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_784_Material_001_0.geometry}
                    material={materials.Material_001}
                  />
                </group>
                <group
                  name="Cube_783"
                  position={[0, 53.52, -4.018]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_783_Material_001_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_783_Material_001_0.geometry}
                    material={materials.Material_001}
                  />
                </group>
                <group
                  name="Cube_782"
                  position={[0, 53.52, 3.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_782_Material_001_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_782_Material_001_0.geometry}
                    material={materials.Material_001}
                  />
                </group>
                <group
                  name="Cube_781"
                  position={[0, 45.52, 3.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_781_Material_001_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_781_Material_001_0.geometry}
                    material={materials.Material_001}
                  />
                </group>
                <group
                  name="Cube_780"
                  position={[0, 45.52, -4.018]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_780_Material_001_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_780_Material_001_0.geometry}
                    material={materials.Material_001}
                  />
                </group>
                <group
                  name="Cube_779"
                  position={[0, 37.52, -2.018]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_779_Material_001_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_779_Material_001_0.geometry}
                    material={materials.Material_001}
                  />
                </group>
                <group
                  name="Cube_778"
                  position={[0, 37.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_778_Material_001_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_778_Material_001_0.geometry}
                    material={materials.Material_001}
                  />
                </group>
                <group
                  name="Cube_777"
                  position={[0, 37.52, -4.018]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_777_Material_001_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_777_Material_001_0.geometry}
                    material={materials.Material_001}
                  />
                </group>
                <group
                  name="Cube_776"
                  position={[0, 37.52, 3.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_776_Material_001_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_776_Material_001_0.geometry}
                    material={materials.Material_001}
                  />
                </group>
                <group
                  name="Cube_775"
                  position={[0, 37.52, 1.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_775_Material_001_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_775_Material_001_0.geometry}
                    material={materials.Material_001}
                  />
                </group>
                <group
                  name="Cube_774"
                  position={[0, 57.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_774_Material_003_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_774_Material_003_0.geometry}
                    material={materials.Material_003}
                  />
                </group>
                <group
                  name="Cube_773"
                  position={[-2, 57.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_773_Material_003_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_773_Material_003_0.geometry}
                    material={materials.Material_003}
                  />
                </group>
                <group
                  name="Cube_772"
                  position={[-4, 57.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_772_Material_003_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_772_Material_003_0.geometry}
                    material={materials.Material_003}
                  />
                </group>
                <group
                  name="Cube_771"
                  position={[2, 57.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_771_Material_003_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_771_Material_003_0.geometry}
                    material={materials.Material_003}
                  />
                </group>
                <group
                  name="Cube_770"
                  position={[4, 57.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_770_Material_003_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_770_Material_003_0.geometry}
                    material={materials.Material_003}
                  />
                </group>
                <group
                  name="Cube_769"
                  position={[4, 49.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_769_Material_003_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_769_Material_003_0.geometry}
                    material={materials.Material_003}
                  />
                </group>
                <group
                  name="Cube_768"
                  position={[2, 49.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_768_Material_003_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_768_Material_003_0.geometry}
                    material={materials.Material_003}
                  />
                </group>
                <group
                  name="Cube_767"
                  position={[-4, 49.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_767_Material_003_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_767_Material_003_0.geometry}
                    material={materials.Material_003}
                  />
                </group>
                <group
                  name="Cube_766"
                  position={[-2, 49.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_766_Material_003_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_766_Material_003_0.geometry}
                    material={materials.Material_003}
                  />
                </group>
                <group
                  name="Cube_765"
                  position={[0, 49.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_765_Material_003_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_765_Material_003_0.geometry}
                    material={materials.Material_003}
                  />
                </group>
                <group
                  name="Cube_764"
                  position={[0, 41.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_764_Material_003_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_764_Material_003_0.geometry}
                    material={materials.Material_003}
                  />
                </group>
                <group
                  name="Cube_763"
                  position={[-2, 41.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_763_Material_003_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_763_Material_003_0.geometry}
                    material={materials.Material_003}
                  />
                </group>
                <group
                  name="Cube_762"
                  position={[-4, 41.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_762_Material_003_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_762_Material_003_0.geometry}
                    material={materials.Material_003}
                  />
                </group>
                <group
                  name="Cube_761"
                  position={[2, 41.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_761_Material_003_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_761_Material_003_0.geometry}
                    material={materials.Material_003}
                  />
                </group>
                <group
                  name="Cube_760"
                  position={[4, 41.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_760_Material_003_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_760_Material_003_0.geometry}
                    material={materials.Material_003}
                  />
                </group>
                <group
                  name="Cube_759"
                  position={[6, 65.52, 7.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_759_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_759_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_758"
                  position={[-6, 65.52, 7.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_758_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_758_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_757"
                  position={[-6, 65.52, -8.018]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_757_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_757_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_756"
                  position={[6, 65.52, -8.018]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_756_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_756_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_755"
                  position={[6, 65.52, -6.018]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_755_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_755_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_754"
                  position={[6, 65.52, 5.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_754_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_754_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_753"
                  position={[6, 41.52, 6.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_753_Material_006_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_753_Material_006_0.geometry}
                    material={materials.Material_006}
                  />
                </group>
                <group
                  name="Cube_752"
                  position={[-6, 65.52, -6.018]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_752_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_752_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_751"
                  position={[-6, 65.52, 5.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_751_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_751_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_750"
                  position={[7, 37.52, 7.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_750_Material_004_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_750_Material_004_0.geometry}
                    material={materials.Material_004}
                  />
                </group>
                <group
                  name="Cube_749"
                  position={[7, 45.52, 7.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_749_Material_004_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_749_Material_004_0.geometry}
                    material={materials.Material_004}
                  />
                </group>
                <group
                  name="Cube_748"
                  position={[7, 53.52, 7.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_748_Material_004_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_748_Material_004_0.geometry}
                    material={materials.Material_004}
                  />
                </group>
                <group
                  name="Cube_747"
                  position={[7, 61.52, 7.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_747_Material_004_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_747_Material_004_0.geometry}
                    material={materials.Material_004}
                  />
                </group>
                <group
                  name="Cube_746"
                  position={[-7, 61.52, 7.982]}
                  rotation={[Math.PI / 2, 0, -Math.PI]}
                >
                  <mesh
                    name="Cube_746_Material_004_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_746_Material_004_0.geometry}
                    material={materials.Material_004}
                  />
                </group>
                <group
                  name="Cube_745"
                  position={[-7, 53.52, 7.982]}
                  rotation={[Math.PI / 2, 0, -Math.PI]}
                >
                  <mesh
                    name="Cube_745_Material_004_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_745_Material_004_0.geometry}
                    material={materials.Material_004}
                  />
                </group>
                <group
                  name="Cube_744"
                  position={[-7, 45.52, 7.982]}
                  rotation={[Math.PI / 2, 0, -Math.PI]}
                >
                  <mesh
                    name="Cube_744_Material_004_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_744_Material_004_0.geometry}
                    material={materials.Material_004}
                  />
                </group>
                <group
                  name="Cube_743"
                  position={[-7, 37.52, 7.982]}
                  rotation={[Math.PI / 2, 0, -Math.PI]}
                >
                  <mesh
                    name="Cube_743_Material_004_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_743_Material_004_0.geometry}
                    material={materials.Material_004}
                  />
                </group>
                <group
                  name="Cube_742"
                  position={[-7, 37.52, -8.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI]}
                >
                  <mesh
                    name="Cube_742_Material_004_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_742_Material_004_0.geometry}
                    material={materials.Material_004}
                  />
                </group>
                <group
                  name="Cube_741"
                  position={[-7, 45.52, -8.018]}
                  rotation={[-Math.PI / 2, 0, Math.PI]}
                >
                  <mesh
                    name="Cube_741_Material_004_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_741_Material_004_0.geometry}
                    material={materials.Material_004}
                  />
                </group>
                <group
                  name="Cube_740"
                  position={[-7, 53.52, -8.018]}
                  rotation={[-Math.PI / 2, 0, Math.PI]}
                >
                  <mesh
                    name="Cube_740_Material_004_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_740_Material_004_0.geometry}
                    material={materials.Material_004}
                  />
                </group>
                <group
                  name="Cube_739"
                  position={[-7, 61.52, -8.018]}
                  rotation={[-Math.PI / 2, 0, Math.PI]}
                >
                  <mesh
                    name="Cube_739_Material_004_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_739_Material_004_0.geometry}
                    material={materials.Material_004}
                  />
                </group>
                <group
                  name="Cube_738"
                  position={[7, 61.52, -8.018]}
                  rotation={[Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_738_Material_004_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_738_Material_004_0.geometry}
                    material={materials.Material_004}
                  />
                </group>
                <group
                  name="Cube_737"
                  position={[7, 53.52, -8.018]}
                  rotation={[Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_737_Material_004_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_737_Material_004_0.geometry}
                    material={materials.Material_004}
                  />
                </group>
                <group
                  name="Cube_736"
                  position={[7, 45.52, -8.018]}
                  rotation={[Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_736_Material_004_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_736_Material_004_0.geometry}
                    material={materials.Material_004}
                  />
                </group>
                <group
                  name="Cube_735"
                  position={[7, 37.52, -8.018]}
                  rotation={[Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_735_Material_004_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_735_Material_004_0.geometry}
                    material={materials.Material_004}
                  />
                </group>
                <group
                  name="Cube_734"
                  position={[8, 55.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_734_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_734_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_733"
                  position={[8, 47.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_733_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_733_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_732"
                  position={[8, 63.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_732_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_732_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_731"
                  position={[8, 39.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_731_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_731_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_730"
                  position={[-8, 39.52, -0.018]}
                  rotation={[Math.PI / 2, 0, Math.PI / 2]}
                >
                  <mesh
                    name="Cube_730_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_730_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_729"
                  position={[-8, 63.52, -0.018]}
                  rotation={[Math.PI / 2, 0, Math.PI / 2]}
                >
                  <mesh
                    name="Cube_729_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_729_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_728"
                  position={[-8, 47.52, -0.018]}
                  rotation={[Math.PI / 2, 0, Math.PI / 2]}
                >
                  <mesh
                    name="Cube_728_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_728_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_727"
                  position={[-8, 55.52, -0.018]}
                  rotation={[Math.PI / 2, 0, Math.PI / 2]}
                >
                  <mesh
                    name="Cube_727_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_727_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_726"
                  position={[0, 55.52, 9.982]}
                  rotation={[-Math.PI / 2, 0, -Math.PI]}
                >
                  <mesh
                    name="Cube_726_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_726_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_725"
                  position={[0, 63.52, 9.982]}
                  rotation={[-Math.PI / 2, 0, -Math.PI]}
                >
                  <mesh
                    name="Cube_725_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_725_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_724"
                  position={[0, 47.52, 9.982]}
                  rotation={[-Math.PI / 2, 0, -Math.PI]}
                >
                  <mesh
                    name="Cube_724_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_724_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_723"
                  position={[0, 39.52, 9.982]}
                  rotation={[-Math.PI / 2, 0, -Math.PI]}
                >
                  <mesh
                    name="Cube_723_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_723_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_722"
                  position={[0, 39.52, -10.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI]}
                >
                  <mesh
                    name="Cube_722_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_722_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_721"
                  position={[0, 47.52, -10.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI]}
                >
                  <mesh
                    name="Cube_721_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_721_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_720"
                  position={[0, 63.52, -10.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI]}
                >
                  <mesh
                    name="Cube_720_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_720_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_719"
                  position={[0, 55.52, -10.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI]}
                >
                  <mesh
                    name="Cube_719_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_719_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_718"
                  position={[-8, 50.52, -10.018]}
                  rotation={[-Math.PI / 2, 0, Math.PI]}
                >
                  <mesh
                    name="Cube_718_Material_004_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_718_Material_004_0.geometry}
                    material={materials.Material_004}
                  />
                </group>
                <group
                  name="Cube_717"
                  position={[-8, 42.52, -10.018]}
                  rotation={[-Math.PI / 2, 0, Math.PI]}
                >
                  <mesh
                    name="Cube_717_Material_004_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_717_Material_004_0.geometry}
                    material={materials.Material_004}
                  />
                </group>
                <group
                  name="Cube_716"
                  position={[-8, 58.52, -10.018]}
                  rotation={[-Math.PI / 2, 0, Math.PI]}
                >
                  <mesh
                    name="Cube_716_Material_004_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_716_Material_004_0.geometry}
                    material={materials.Material_004}
                  />
                </group>
                <group
                  name="Cube_715"
                  position={[-8, 66.52, -10.018]}
                  rotation={[-Math.PI / 2, 0, Math.PI]}
                >
                  <mesh
                    name="Cube_715_Material_004_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_715_Material_004_0.geometry}
                    material={materials.Material_004}
                  />
                </group>
                <group
                  name="Cube_714"
                  position={[8, 66.52, -10.018]}
                  rotation={[-Math.PI / 2, 0, 1.571]}
                >
                  <mesh
                    name="Cube_714_Material_004_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_714_Material_004_0.geometry}
                    material={materials.Material_004}
                  />
                </group>
                <group
                  name="Cube_713"
                  position={[8, 58.52, -10.018]}
                  rotation={[-Math.PI / 2, 0, 1.571]}
                >
                  <mesh
                    name="Cube_713_Material_004_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_713_Material_004_0.geometry}
                    material={materials.Material_004}
                  />
                </group>
                <group
                  name="Cube_712"
                  position={[8, 42.52, -10.018]}
                  rotation={[-Math.PI / 2, 0, 1.571]}
                >
                  <mesh
                    name="Cube_712_Material_004_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_712_Material_004_0.geometry}
                    material={materials.Material_004}
                  />
                </group>
                <group
                  name="Cube_711"
                  position={[8, 50.52, -10.018]}
                  rotation={[-Math.PI / 2, 0, 1.571]}
                >
                  <mesh
                    name="Cube_711_Material_004_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_711_Material_004_0.geometry}
                    material={materials.Material_004}
                  />
                </group>
                <group
                  name="Cube_710"
                  position={[8, 50.52, 9.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_710_Material_004_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_710_Material_004_0.geometry}
                    material={materials.Material_004}
                  />
                </group>
                <group
                  name="Cube_709"
                  position={[8, 42.52, 9.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_709_Material_004_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_709_Material_004_0.geometry}
                    material={materials.Material_004}
                  />
                </group>
                <group
                  name="Cube_708"
                  position={[8, 58.52, 9.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_708_Material_004_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_708_Material_004_0.geometry}
                    material={materials.Material_004}
                  />
                </group>
                <group
                  name="Cube_707"
                  position={[8, 66.52, 9.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_707_Material_004_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_707_Material_004_0.geometry}
                    material={materials.Material_004}
                  />
                </group>
                <group
                  name="Cube_706"
                  position={[-8, 66.52, 9.982]}
                  rotation={[-Math.PI / 2, 0, -1.571]}
                >
                  <mesh
                    name="Cube_706_Material_004_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_706_Material_004_0.geometry}
                    material={materials.Material_004}
                  />
                </group>
                <group
                  name="Cube_705"
                  position={[-8, 58.52, 9.982]}
                  rotation={[-Math.PI / 2, 0, -1.571]}
                >
                  <mesh
                    name="Cube_705_Material_004_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_705_Material_004_0.geometry}
                    material={materials.Material_004}
                  />
                </group>
                <group
                  name="Cube_704"
                  position={[-8, 42.52, 9.982]}
                  rotation={[-Math.PI / 2, 0, -1.571]}
                >
                  <mesh
                    name="Cube_704_Material_004_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_704_Material_004_0.geometry}
                    material={materials.Material_004}
                  />
                </group>
                <group
                  name="Cube_703"
                  position={[-8, 50.52, 9.982]}
                  rotation={[-Math.PI / 2, 0, -1.571]}
                >
                  <mesh
                    name="Cube_703_Material_004_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_703_Material_004_0.geometry}
                    material={materials.Material_004}
                  />
                </group>
                <group
                  name="Cube_702"
                  position={[4, 67.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_702_Material_003_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_702_Material_003_0.geometry}
                    material={materials.Material_003}
                  />
                </group>
                <group
                  name="Cube_701"
                  position={[2, 67.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_701_Material_003_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_701_Material_003_0.geometry}
                    material={materials.Material_003}
                  />
                </group>
                <group
                  name="Cube_700"
                  position={[-4, 67.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_700_Material_003_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_700_Material_003_0.geometry}
                    material={materials.Material_003}
                  />
                </group>
                <group
                  name="Cube_699"
                  position={[-2, 67.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_699_Material_003_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_699_Material_003_0.geometry}
                    material={materials.Material_003}
                  />
                </group>
                <group
                  name="Cube_698"
                  position={[0, 67.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_698_Material_003_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_698_Material_003_0.geometry}
                    material={materials.Material_003}
                  />
                </group>
                <group
                  name="Cube_697"
                  position={[6, 41.52, -7.018]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_697_Material_006_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_697_Material_006_0.geometry}
                    material={materials.Material_006}
                  />
                </group>
                <group
                  name="Cube_696"
                  position={[-6, 41.52, -7.018]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_696_Material_006_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_696_Material_006_0.geometry}
                    material={materials.Material_006}
                  />
                </group>
                <group
                  name="Cube_695"
                  position={[-6, 41.52, 6.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_695_Material_006_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_695_Material_006_0.geometry}
                    material={materials.Material_006}
                  />
                </group>
                <group
                  name="Cube_694"
                  position={[-6, 49.52, 6.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_694_Material_006_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_694_Material_006_0.geometry}
                    material={materials.Material_006}
                  />
                </group>
                <group
                  name="Cube_693"
                  position={[-6, 49.52, -7.018]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_693_Material_006_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_693_Material_006_0.geometry}
                    material={materials.Material_006}
                  />
                </group>
                <group
                  name="Cube_692"
                  position={[6, 49.52, -7.018]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_692_Material_006_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_692_Material_006_0.geometry}
                    material={materials.Material_006}
                  />
                </group>
                <group
                  name="Cube_691"
                  position={[6, 49.52, 6.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_691_Material_006_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_691_Material_006_0.geometry}
                    material={materials.Material_006}
                  />
                </group>
                <group
                  name="Cube_690"
                  position={[6, 57.52, 6.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_690_Material_006_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_690_Material_006_0.geometry}
                    material={materials.Material_006}
                  />
                </group>
                <group
                  name="Cube_689"
                  position={[6, 57.52, -7.018]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_689_Material_006_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_689_Material_006_0.geometry}
                    material={materials.Material_006}
                  />
                </group>
                <group
                  name="Cube_688"
                  position={[-6, 57.52, -7.018]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_688_Material_006_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_688_Material_006_0.geometry}
                    material={materials.Material_006}
                  />
                </group>
                <group
                  name="Cube_687"
                  position={[-6, 57.52, 6.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_687_Material_006_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_687_Material_006_0.geometry}
                    material={materials.Material_006}
                  />
                </group>
                <group
                  name="Cube_686"
                  position={[6, 67.52, 2.982]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_686_Material_007_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_686_Material_007_0.geometry}
                    material={materials.Material_007}
                  />
                </group>
                <group
                  name="Cube_685"
                  position={[-6, 67.52, 2.982]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_685_Material_007_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_685_Material_007_0.geometry}
                    material={materials.Material_007}
                  />
                </group>
                <group
                  name="Cube_684"
                  position={[-6, 67.52, -3.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_684_Material_007_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_684_Material_007_0.geometry}
                    material={materials.Material_007}
                  />
                </group>
                <group
                  name="Cube_683"
                  position={[3, 65.52, -8.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI]}
                >
                  <mesh
                    name="Cube_683_Material_007_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_683_Material_007_0.geometry}
                    material={materials.Material_007}
                  />
                </group>
                <group
                  name="Cube_682"
                  position={[-3, 65.52, -8.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI]}
                >
                  <mesh
                    name="Cube_682_Material_007_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_682_Material_007_0.geometry}
                    material={materials.Material_007}
                  />
                </group>
                <group
                  name="Cube_681"
                  position={[-3, 59.52, -8.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI]}
                >
                  <mesh
                    name="Cube_681_Material_007_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_681_Material_007_0.geometry}
                    material={materials.Material_007}
                  />
                </group>
                <group
                  name="Cube_680"
                  position={[3, 59.52, -8.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI]}
                >
                  <mesh
                    name="Cube_680_Material_007_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_680_Material_007_0.geometry}
                    material={materials.Material_007}
                  />
                </group>
                <group
                  name="Cube_679"
                  position={[3, 51.52, -8.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI]}
                >
                  <mesh
                    name="Cube_679_Material_007_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_679_Material_007_0.geometry}
                    material={materials.Material_007}
                  />
                </group>
                <group
                  name="Cube_678"
                  position={[-3, 51.52, -8.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI]}
                >
                  <mesh
                    name="Cube_678_Material_007_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_678_Material_007_0.geometry}
                    material={materials.Material_007}
                  />
                </group>
                <group
                  name="Cube_677"
                  position={[-3, 43.52, -8.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI]}
                >
                  <mesh
                    name="Cube_677_Material_007_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_677_Material_007_0.geometry}
                    material={materials.Material_007}
                  />
                </group>
                <group
                  name="Cube_676"
                  position={[3, 43.52, -8.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI]}
                >
                  <mesh
                    name="Cube_676_Material_007_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_676_Material_007_0.geometry}
                    material={materials.Material_007}
                  />
                </group>
                <group
                  name="Cube_675"
                  position={[3, 43.52, 7.982]}
                  rotation={[-Math.PI / 2, 0, -Math.PI]}
                >
                  <mesh
                    name="Cube_675_Material_007_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_675_Material_007_0.geometry}
                    material={materials.Material_007}
                  />
                </group>
                <group
                  name="Cube_674"
                  position={[-3, 43.52, 7.982]}
                  rotation={[-Math.PI / 2, 0, -Math.PI]}
                >
                  <mesh
                    name="Cube_674_Material_007_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_674_Material_007_0.geometry}
                    material={materials.Material_007}
                  />
                </group>
                <group
                  name="Cube_673"
                  position={[-3, 51.52, 7.982]}
                  rotation={[-Math.PI / 2, 0, -Math.PI]}
                >
                  <mesh
                    name="Cube_673_Material_007_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_673_Material_007_0.geometry}
                    material={materials.Material_007}
                  />
                </group>
                <group
                  name="Cube_672"
                  position={[3, 51.52, 7.982]}
                  rotation={[-Math.PI / 2, 0, -Math.PI]}
                >
                  <mesh
                    name="Cube_672_Material_007_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_672_Material_007_0.geometry}
                    material={materials.Material_007}
                  />
                </group>
                <group
                  name="Cube_671"
                  position={[3, 59.52, 7.982]}
                  rotation={[-Math.PI / 2, 0, -Math.PI]}
                >
                  <mesh
                    name="Cube_671_Material_007_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_671_Material_007_0.geometry}
                    material={materials.Material_007}
                  />
                </group>
                <group
                  name="Cube_670"
                  position={[-3, 59.52, 7.982]}
                  rotation={[-Math.PI / 2, 0, -Math.PI]}
                >
                  <mesh
                    name="Cube_670_Material_007_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_670_Material_007_0.geometry}
                    material={materials.Material_007}
                  />
                </group>
                <group
                  name="Cube_669"
                  position={[-3, 65.52, 7.982]}
                  rotation={[-Math.PI / 2, 0, -Math.PI]}
                >
                  <mesh
                    name="Cube_669_Material_007_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_669_Material_007_0.geometry}
                    material={materials.Material_007}
                  />
                </group>
                <group
                  name="Cube_668"
                  position={[3, 65.52, 7.982]}
                  rotation={[-Math.PI / 2, 0, -Math.PI]}
                >
                  <mesh
                    name="Cube_668_Material_007_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_668_Material_007_0.geometry}
                    material={materials.Material_007}
                  />
                </group>
                <group
                  name="Cube_667"
                  position={[-0.467, 70.52, 0.716]}
                  rotation={[-Math.PI / 2, 0, 1.571]}
                >
                  <mesh
                    name="Cube_667_Material_004_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_667_Material_004_0.geometry}
                    material={materials.Material_004}
                  />
                </group>
                <group
                  name="Cube_666"
                  position={[-0.467, 70.52, 0.716]}
                  rotation={[-Math.PI / 2, 0, 1.571]}
                >
                  <mesh
                    name="Cube_666_Material_004_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_666_Material_004_0.geometry}
                    material={materials.Material_004}
                  />
                </group>
                <group
                  name="Cube_665"
                  position={[-0.467, 70.52, 0.716]}
                  rotation={[-Math.PI / 2, 0, 1.571]}
                >
                  <mesh
                    name="Cube_665_Material_004_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_665_Material_004_0.geometry}
                    material={materials.Material_004}
                  />
                </group>
                <group
                  name="Cube_664"
                  position={[6, 53.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_664_Material_008_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_664_Material_008_0.geometry}
                    material={materials.Material_008}
                  />
                </group>
                <group
                  name="Cube_663"
                  position={[6, 49.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_663_Material_008_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_663_Material_008_0.geometry}
                    material={materials.Material_008}
                  />
                </group>
                <group
                  name="Cube_662"
                  position={[6, 45.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_662_Material_008_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_662_Material_008_0.geometry}
                    material={materials.Material_008}
                  />
                </group>
                <group
                  name="Cube_661"
                  position={[6, 41.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_661_Material_008_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_661_Material_008_0.geometry}
                    material={materials.Material_008}
                  />
                </group>
                <group
                  name="Cube_660"
                  position={[-6, 41.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_660_Material_008_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_660_Material_008_0.geometry}
                    material={materials.Material_008}
                  />
                </group>
                <group
                  name="Cube_659"
                  position={[-6, 45.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_659_Material_008_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_659_Material_008_0.geometry}
                    material={materials.Material_008}
                  />
                </group>
                <group
                  name="Cube_658"
                  position={[-6, 49.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_658_Material_008_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_658_Material_008_0.geometry}
                    material={materials.Material_008}
                  />
                </group>
                <group
                  name="Cube_657"
                  position={[-6, 53.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_657_Material_008_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_657_Material_008_0.geometry}
                    material={materials.Material_008}
                  />
                </group>
                <group
                  name="Cube_656"
                  position={[-6, 57.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_656_Material_008_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_656_Material_008_0.geometry}
                    material={materials.Material_008}
                  />
                </group>
                <group
                  name="Cube_655"
                  position={[6, 57.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_655_Material_008_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_655_Material_008_0.geometry}
                    material={materials.Material_008}
                  />
                </group>
                <group
                  name="Cube_654"
                  position={[6, 61.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_654_Material_008_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_654_Material_008_0.geometry}
                    material={materials.Material_008}
                  />
                </group>
                <group
                  name="Cube_653"
                  position={[-6, 61.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_653_Material_008_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_653_Material_008_0.geometry}
                    material={materials.Material_008}
                  />
                </group>
                <group
                  name="Cube_652"
                  position={[-6.01, 65.493, -0.011]}
                  rotation={[-1.571, 0, -1.571]}
                >
                  <mesh
                    name="Cube_652_Material_008_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_652_Material_008_0.geometry}
                    material={materials.Material_008}
                  />
                </group>
                <group
                  name="Cube_651"
                  position={[6.025, 65.49, -0.005]}
                  rotation={[-1.571, 0, -1.572]}
                >
                  <mesh
                    name="Cube_651_Material_008_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_651_Material_008_0.geometry}
                    material={materials.Material_008}
                  />
                </group>
                <group
                  name="Cube_650"
                  position={[-6, 50.52, 3.982]}
                  rotation={[0, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_650_Material_007_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_650_Material_007_0.geometry}
                    material={materials.Material_007}
                  />
                </group>
                <group
                  name="Cube_649"
                  position={[-6, 50.52, -4.018]}
                  rotation={[0, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_649_Material_007_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_649_Material_007_0.geometry}
                    material={materials.Material_007}
                  />
                </group>
                <group
                  name="Cube_648"
                  position={[-6, 42.52, -4.018]}
                  rotation={[0, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_648_Material_007_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_648_Material_007_0.geometry}
                    material={materials.Material_007}
                  />
                </group>
                <group
                  name="Cube_647"
                  position={[-6, 42.52, 3.982]}
                  rotation={[0, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_647_Material_007_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_647_Material_007_0.geometry}
                    material={materials.Material_007}
                  />
                </group>
                <group
                  name="Cube_646"
                  position={[-6, 58.52, -4.018]}
                  rotation={[0, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_646_Material_007_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_646_Material_007_0.geometry}
                    material={materials.Material_007}
                  />
                </group>
                <group
                  name="Cube_645"
                  position={[-6, 58.52, 3.982]}
                  rotation={[0, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_645_Material_007_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_645_Material_007_0.geometry}
                    material={materials.Material_007}
                  />
                </group>
                <group
                  name="Cube_644"
                  position={[6, 58.52, 3.982]}
                  rotation={[0, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_644_Material_007_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_644_Material_007_0.geometry}
                    material={materials.Material_007}
                  />
                </group>
                <group
                  name="Cube_643"
                  position={[6, 58.52, -4.018]}
                  rotation={[0, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_643_Material_007_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_643_Material_007_0.geometry}
                    material={materials.Material_007}
                  />
                </group>
                <group
                  name="Cube_642"
                  position={[6, 42.52, 3.982]}
                  rotation={[0, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_642_Material_007_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_642_Material_007_0.geometry}
                    material={materials.Material_007}
                  />
                </group>
                <group
                  name="Cube_641"
                  position={[6, 42.52, -4.018]}
                  rotation={[0, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_641_Material_007_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_641_Material_007_0.geometry}
                    material={materials.Material_007}
                  />
                </group>
                <group
                  name="Cube_640"
                  position={[6, 50.52, -4.018]}
                  rotation={[0, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_640_Material_007_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_640_Material_007_0.geometry}
                    material={materials.Material_007}
                  />
                </group>
                <group
                  name="Cube_639"
                  position={[6, 50.52, 3.982]}
                  rotation={[0, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_639_Material_007_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_639_Material_007_0.geometry}
                    material={materials.Material_007}
                  />
                </group>
                <group
                  name="Cube_638"
                  position={[0.005, 51.543, -10.021]}
                  rotation={[0, 0.012, -1.571]}
                >
                  <mesh
                    name="Cube_638_Material_008_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_638_Material_008_0.geometry}
                    material={materials.Material_008}
                  />
                </group>
                <group
                  name="Cube_637"
                  position={[0.005, 43.543, -10.021]}
                  rotation={[0, 0.013, -1.571]}
                >
                  <mesh
                    name="Cube_637_Material_008_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_637_Material_008_0.geometry}
                    material={materials.Material_008}
                  />
                </group>
                <group
                  name="Cube_636"
                  position={[0.005, 59.543, -10.021]}
                  rotation={[0, 0.013, -1.571]}
                >
                  <mesh
                    name="Cube_636_Material_008_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_636_Material_008_0.geometry}
                    material={materials.Material_008}
                  />
                </group>
                <group
                  name="Cube_635"
                  position={[0.005, 59.543, 9.979]}
                  rotation={[0, 0.013, -1.571]}
                >
                  <mesh
                    name="Cube_635_Material_008_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_635_Material_008_0.geometry}
                    material={materials.Material_008}
                  />
                </group>
                <group
                  name="Cube_634"
                  position={[0.005, 43.543, 9.979]}
                  rotation={[0, 0.013, -1.571]}
                >
                  <mesh
                    name="Cube_634_Material_008_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_634_Material_008_0.geometry}
                    material={materials.Material_008}
                  />
                </group>
                <group
                  name="Cube_633"
                  position={[0.005, 51.543, 9.979]}
                  rotation={[0, 0.012, -1.571]}
                >
                  <mesh
                    name="Cube_633_Material_008_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_633_Material_008_0.geometry}
                    material={materials.Material_008}
                  />
                </group>
                <group
                  name="Cube_632"
                  position={[0, 66.52, 9.982]}
                  rotation={[0, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_632_Material_007_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_632_Material_007_0.geometry}
                    material={materials.Material_007}
                  />
                </group>
                <group
                  name="Cube_631"
                  position={[0, 66.52, -10.018]}
                  rotation={[0, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_631_Material_007_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_631_Material_007_0.geometry}
                    material={materials.Material_007}
                  />
                </group>
                <group
                  name="Cube_630"
                  position={[8, 66.52, -0.018]}
                  rotation={[0, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_630_Material_007_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_630_Material_007_0.geometry}
                    material={materials.Material_007}
                  />
                </group>
                <group
                  name="Cube_629"
                  position={[-8, 66.52, -0.018]}
                  rotation={[0, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_629_Material_007_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_629_Material_007_0.geometry}
                    material={materials.Material_007}
                  />
                </group>
                <group
                  name="Cube_628"
                  position={[8.005, 51.543, -0.021]}
                  rotation={[0, 0.012, -1.571]}
                >
                  <mesh
                    name="Cube_628_Material_008_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_628_Material_008_0.geometry}
                    material={materials.Material_008}
                  />
                </group>
                <group
                  name="Cube_627"
                  position={[8.005, 43.543, -0.021]}
                  rotation={[0, 0.013, -1.571]}
                >
                  <mesh
                    name="Cube_627_Material_008_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_627_Material_008_0.geometry}
                    material={materials.Material_008}
                  />
                </group>
                <group
                  name="Cube_626"
                  position={[8.005, 59.543, -0.021]}
                  rotation={[0, 0.013, -1.571]}
                >
                  <mesh
                    name="Cube_626_Material_008_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_626_Material_008_0.geometry}
                    material={materials.Material_008}
                  />
                </group>
                <group
                  name="Cube_625"
                  position={[-7.995, 59.543, -0.021]}
                  rotation={[0, 0.013, -1.571]}
                >
                  <mesh
                    name="Cube_625_Material_008_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_625_Material_008_0.geometry}
                    material={materials.Material_008}
                  />
                </group>
                <group
                  name="Cube_624"
                  position={[-7.995, 43.543, -0.021]}
                  rotation={[0, 0.013, -1.571]}
                >
                  <mesh
                    name="Cube_624_Material_008_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_624_Material_008_0.geometry}
                    material={materials.Material_008}
                  />
                </group>
                <group
                  name="Cube_623"
                  position={[-7.995, 51.543, -0.021]}
                  rotation={[0, 0.012, -1.571]}
                >
                  <mesh
                    name="Cube_623_Material_008_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_623_Material_008_0.geometry}
                    material={materials.Material_008}
                  />
                </group>
                <group
                  name="Cube_622"
                  position={[-7.995, 15.543, -0.021]}
                  rotation={[0, 0.012, -1.571]}
                >
                  <mesh
                    name="Cube_622_Material_008_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_622_Material_008_0.geometry}
                    material={materials.Material_008}
                  />
                </group>
                <group
                  name="Cube_621"
                  position={[-7.995, 7.543, -0.021]}
                  rotation={[0, 0.013, -1.571]}
                >
                  <mesh
                    name="Cube_621_Material_008_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_621_Material_008_0.geometry}
                    material={materials.Material_008}
                  />
                </group>
                <group
                  name="Cube_620"
                  position={[-7.995, 23.543, -0.021]}
                  rotation={[0, 0.013, -1.571]}
                >
                  <mesh
                    name="Cube_620_Material_008_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_620_Material_008_0.geometry}
                    material={materials.Material_008}
                  />
                </group>
                <group
                  name="Cube_619"
                  position={[8.005, 23.543, -0.021]}
                  rotation={[0, 0.013, -1.571]}
                >
                  <mesh
                    name="Cube_619_Material_008_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_619_Material_008_0.geometry}
                    material={materials.Material_008}
                  />
                </group>
                <group
                  name="Cube_618"
                  position={[8.005, 7.543, -0.021]}
                  rotation={[0, 0.013, -1.571]}
                >
                  <mesh
                    name="Cube_618_Material_008_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_618_Material_008_0.geometry}
                    material={materials.Material_008}
                  />
                </group>
                <group
                  name="Cube_617"
                  position={[8.005, 15.543, -0.021]}
                  rotation={[0, 0.012, -1.571]}
                >
                  <mesh
                    name="Cube_617_Material_008_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_617_Material_008_0.geometry}
                    material={materials.Material_008}
                  />
                </group>
                <group
                  name="Cube_616"
                  position={[-8, 30.52, -0.018]}
                  rotation={[0, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_616_Material_007_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_616_Material_007_0.geometry}
                    material={materials.Material_007}
                  />
                </group>
                <group
                  name="Cube_615"
                  position={[8, 30.52, -0.018]}
                  rotation={[0, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_615_Material_007_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_615_Material_007_0.geometry}
                    material={materials.Material_007}
                  />
                </group>
                <group
                  name="Cube_614"
                  position={[0, 30.52, -10.018]}
                  rotation={[0, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_614_Material_007_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_614_Material_007_0.geometry}
                    material={materials.Material_007}
                  />
                </group>
                <group
                  name="Cube_613"
                  position={[0, 30.52, 9.982]}
                  rotation={[0, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_613_Material_007_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_613_Material_007_0.geometry}
                    material={materials.Material_007}
                  />
                </group>
                <group
                  name="Cube_612"
                  position={[0.005, 15.543, 9.979]}
                  rotation={[0, 0.012, -1.571]}
                >
                  <mesh
                    name="Cube_612_Material_008_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_612_Material_008_0.geometry}
                    material={materials.Material_008}
                  />
                </group>
                <group
                  name="Cube_611"
                  position={[0.005, 7.543, 9.979]}
                  rotation={[0, 0.013, -1.571]}
                >
                  <mesh
                    name="Cube_611_Material_008_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_611_Material_008_0.geometry}
                    material={materials.Material_008}
                  />
                </group>
                <group
                  name="Cube_610"
                  position={[0.005, 23.543, 9.979]}
                  rotation={[0, 0.013, -1.571]}
                >
                  <mesh
                    name="Cube_610_Material_008_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_610_Material_008_0.geometry}
                    material={materials.Material_008}
                  />
                </group>
                <group
                  name="Cube_609"
                  position={[0.005, 23.543, -10.021]}
                  rotation={[0, 0.013, -1.571]}
                >
                  <mesh
                    name="Cube_609_Material_008_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_609_Material_008_0.geometry}
                    material={materials.Material_008}
                  />
                </group>
                <group
                  name="Cube_608"
                  position={[0.005, 7.543, -10.021]}
                  rotation={[0, 0.013, -1.571]}
                >
                  <mesh
                    name="Cube_608_Material_008_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_608_Material_008_0.geometry}
                    material={materials.Material_008}
                  />
                </group>
                <group
                  name="Cube_063"
                  position={[0.005, 15.543, -10.021]}
                  rotation={[0, 0.012, -1.571]}
                >
                  <mesh
                    name="Cube_063_Material_008_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_063_Material_008_0.geometry}
                    material={materials.Material_008}
                  />
                </group>
                <group
                  name="Cube_060"
                  position={[6, 14.52, 3.982]}
                  rotation={[0, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_060_Material_007_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_060_Material_007_0.geometry}
                    material={materials.Material_007}
                  />
                </group>
                <group
                  name="Cube_059"
                  position={[6, 14.52, -4.018]}
                  rotation={[0, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_059_Material_007_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_059_Material_007_0.geometry}
                    material={materials.Material_007}
                  />
                </group>
                <group
                  name="Cube_053"
                  position={[6, 6.52, -4.018]}
                  rotation={[0, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_053_Material_007_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_053_Material_007_0.geometry}
                    material={materials.Material_007}
                  />
                </group>
                <group
                  name="Cube_052"
                  position={[6, 6.52, 3.982]}
                  rotation={[0, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_052_Material_007_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_052_Material_007_0.geometry}
                    material={materials.Material_007}
                  />
                </group>
                <group
                  name="Cube_047"
                  position={[6, 22.52, -4.018]}
                  rotation={[0, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_047_Material_007_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_047_Material_007_0.geometry}
                    material={materials.Material_007}
                  />
                </group>
                <group
                  name="Cube_016"
                  position={[6, 22.52, 3.982]}
                  rotation={[0, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_016_Material_007_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_016_Material_007_0.geometry}
                    material={materials.Material_007}
                  />
                </group>
                <group
                  name="Cube_015"
                  position={[-6, 22.52, 3.982]}
                  rotation={[0, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_015_Material_007_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_015_Material_007_0.geometry}
                    material={materials.Material_007}
                  />
                </group>
                <group
                  name="Cube_011"
                  position={[-6, 22.52, -4.018]}
                  rotation={[0, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_011_Material_007_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_011_Material_007_0.geometry}
                    material={materials.Material_007}
                  />
                </group>
                <group
                  name="Cube_009"
                  position={[-6, 6.52, 3.982]}
                  rotation={[0, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_009_Material_007_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_009_Material_007_0.geometry}
                    material={materials.Material_007}
                  />
                </group>
                <group
                  name="Cube_008"
                  position={[-6, 6.52, -4.018]}
                  rotation={[0, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_008_Material_007_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_008_Material_007_0.geometry}
                    material={materials.Material_007}
                  />
                </group>
                <group
                  name="Cube_010"
                  position={[-6, 14.52, -4.018]}
                  rotation={[0, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_010_Material_007_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_010_Material_007_0.geometry}
                    material={materials.Material_007}
                  />
                </group>
                <group
                  name="Cube_040"
                  position={[-6, 14.52, 3.982]}
                  rotation={[0, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_040_Material_007_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_040_Material_007_0.geometry}
                    material={materials.Material_007}
                  />
                </group>
                <group
                  name="Cube_034"
                  position={[6.025, 29.49, -0.005]}
                  rotation={[-1.571, 0, -1.572]}
                >
                  <mesh
                    name="Cube_034_Material_008_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_034_Material_008_0.geometry}
                    material={materials.Material_008}
                  />
                </group>
                <group
                  name="Cube_029"
                  position={[-6.01, 29.493, -0.011]}
                  rotation={[-1.571, 0, -1.571]}
                >
                  <mesh
                    name="Cube_029_Material_008_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_029_Material_008_0.geometry}
                    material={materials.Material_008}
                  />
                </group>
                <group
                  name="Cube_035"
                  position={[-6, 25.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_035_Material_008_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_035_Material_008_0.geometry}
                    material={materials.Material_008}
                  />
                </group>
                <group
                  name="Cube_004"
                  position={[6, 25.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_004_Material_008_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_004_Material_008_0.geometry}
                    material={materials.Material_008}
                  />
                </group>
                <group
                  name="Cube_028"
                  position={[6, 21.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_028_Material_008_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_028_Material_008_0.geometry}
                    material={materials.Material_008}
                  />
                </group>
                <group
                  name="Cube_023"
                  position={[-6, 21.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_023_Material_008_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_023_Material_008_0.geometry}
                    material={materials.Material_008}
                  />
                </group>
                <group
                  name="Cube_607"
                  position={[-6, 17.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_607_Material_008_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_607_Material_008_0.geometry}
                    material={materials.Material_008}
                  />
                </group>
                <group
                  name="Cube_606"
                  position={[-6, 13.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_606_Material_008_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_606_Material_008_0.geometry}
                    material={materials.Material_008}
                  />
                </group>
                <group
                  name="Cube_605"
                  position={[-6, 9.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_605_Material_008_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_605_Material_008_0.geometry}
                    material={materials.Material_008}
                  />
                </group>
                <group
                  name="Cube_046"
                  position={[-6, 5.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_046_Material_008_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_046_Material_008_0.geometry}
                    material={materials.Material_008}
                  />
                </group>
                <group
                  name="Cube_041"
                  position={[6, 5.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_041_Material_008_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_041_Material_008_0.geometry}
                    material={materials.Material_008}
                  />
                </group>
                <group
                  name="Cube_022"
                  position={[6, 9.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_022_Material_008_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_022_Material_008_0.geometry}
                    material={materials.Material_008}
                  />
                </group>
                <group
                  name="Cube_006"
                  position={[6, 13.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_006_Material_008_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_006_Material_008_0.geometry}
                    material={materials.Material_008}
                  />
                </group>
                <group
                  name="Cube_005"
                  position={[6, 17.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_005_Material_008_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_005_Material_008_0.geometry}
                    material={materials.Material_008}
                  />
                </group>
                <group
                  name="Cube_604"
                  position={[-0.467, 34.52, 0.716]}
                  rotation={[-Math.PI / 2, 0, 1.571]}
                >
                  <mesh
                    name="Cube_604_Material_004_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_604_Material_004_0.geometry}
                    material={materials.Material_004}
                  />
                </group>
                <group
                  name="Cube_603"
                  position={[-0.467, 34.52, 0.716]}
                  rotation={[-Math.PI / 2, 0, 1.571]}
                >
                  <mesh
                    name="Cube_603_Material_004_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_603_Material_004_0.geometry}
                    material={materials.Material_004}
                  />
                </group>
                <group
                  name="Cube_602"
                  position={[-0.467, 34.52, 0.716]}
                  rotation={[-Math.PI / 2, 0, 1.571]}
                >
                  <mesh
                    name="Cube_602_Material_004_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_602_Material_004_0.geometry}
                    material={materials.Material_004}
                  />
                </group>
                <group
                  name="Cube_598"
                  position={[3, 29.52, 7.982]}
                  rotation={[-Math.PI / 2, 0, -Math.PI]}
                >
                  <mesh
                    name="Cube_598_Material_007_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_598_Material_007_0.geometry}
                    material={materials.Material_007}
                  />
                </group>
                <group
                  name="Cube_597"
                  position={[-3, 29.52, 7.982]}
                  rotation={[-Math.PI / 2, 0, -Math.PI]}
                >
                  <mesh
                    name="Cube_597_Material_007_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_597_Material_007_0.geometry}
                    material={materials.Material_007}
                  />
                </group>
                <group
                  name="Cube_596"
                  position={[-3, 23.52, 7.982]}
                  rotation={[-Math.PI / 2, 0, -Math.PI]}
                >
                  <mesh
                    name="Cube_596_Material_007_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_596_Material_007_0.geometry}
                    material={materials.Material_007}
                  />
                </group>
                <group
                  name="Cube_595"
                  position={[3, 23.52, 7.982]}
                  rotation={[-Math.PI / 2, 0, -Math.PI]}
                >
                  <mesh
                    name="Cube_595_Material_007_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_595_Material_007_0.geometry}
                    material={materials.Material_007}
                  />
                </group>
                <group
                  name="Cube_594"
                  position={[3, 15.52, 7.982]}
                  rotation={[-Math.PI / 2, 0, -Math.PI]}
                >
                  <mesh
                    name="Cube_594_Material_007_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_594_Material_007_0.geometry}
                    material={materials.Material_007}
                  />
                </group>
                <group
                  name="Cube_593"
                  position={[-3, 15.52, 7.982]}
                  rotation={[-Math.PI / 2, 0, -Math.PI]}
                >
                  <mesh
                    name="Cube_593_Material_007_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_593_Material_007_0.geometry}
                    material={materials.Material_007}
                  />
                </group>
                <group
                  name="Cube_592"
                  position={[-3, 7.52, 7.982]}
                  rotation={[-Math.PI / 2, 0, -Math.PI]}
                >
                  <mesh
                    name="Cube_592_Material_007_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_592_Material_007_0.geometry}
                    material={materials.Material_007}
                  />
                </group>
                <group
                  name="Cube_591"
                  position={[3, 7.52, 7.982]}
                  rotation={[-Math.PI / 2, 0, -Math.PI]}
                >
                  <mesh
                    name="Cube_591_Material_007_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_591_Material_007_0.geometry}
                    material={materials.Material_007}
                  />
                </group>
                <group
                  name="Cube_590"
                  position={[3, 7.52, -8.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI]}
                >
                  <mesh
                    name="Cube_590_Material_007_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_590_Material_007_0.geometry}
                    material={materials.Material_007}
                  />
                </group>
                <group
                  name="Cube_589"
                  position={[-3, 7.52, -8.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI]}
                >
                  <mesh
                    name="Cube_589_Material_007_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_589_Material_007_0.geometry}
                    material={materials.Material_007}
                  />
                </group>
                <group
                  name="Cube_588"
                  position={[-3, 15.52, -8.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI]}
                >
                  <mesh
                    name="Cube_588_Material_007_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_588_Material_007_0.geometry}
                    material={materials.Material_007}
                  />
                </group>
                <group
                  name="Cube_587"
                  position={[3, 15.52, -8.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI]}
                >
                  <mesh
                    name="Cube_587_Material_007_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_587_Material_007_0.geometry}
                    material={materials.Material_007}
                  />
                </group>
                <group
                  name="Cube_586"
                  position={[3, 23.52, -8.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI]}
                >
                  <mesh
                    name="Cube_586_Material_007_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_586_Material_007_0.geometry}
                    material={materials.Material_007}
                  />
                </group>
                <group
                  name="Cube_585"
                  position={[-3, 23.52, -8.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI]}
                >
                  <mesh
                    name="Cube_585_Material_007_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_585_Material_007_0.geometry}
                    material={materials.Material_007}
                  />
                </group>
                <group
                  name="Cube_057"
                  position={[-3, 29.52, -8.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI]}
                >
                  <mesh
                    name="Cube_057_Material_007_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_057_Material_007_0.geometry}
                    material={materials.Material_007}
                  />
                </group>
                <group
                  name="Cube_054"
                  position={[3, 29.52, -8.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI]}
                >
                  <mesh
                    name="Cube_054_Material_007_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_054_Material_007_0.geometry}
                    material={materials.Material_007}
                  />
                </group>
                <group
                  name="Cube_033"
                  position={[-6, 31.52, -3.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_033_Material_007_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_033_Material_007_0.geometry}
                    material={materials.Material_007}
                  />
                </group>
                <group
                  name="Cube_018"
                  position={[-6, 31.52, 2.982]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_018_Material_007_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_018_Material_007_0.geometry}
                    material={materials.Material_007}
                  />
                </group>
                <group
                  name="Cube_584"
                  position={[6, 31.52, 2.982]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_584_Material_007_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_584_Material_007_0.geometry}
                    material={materials.Material_007}
                  />
                </group>
                <group
                  name="Cube_583"
                  position={[-6, 21.52, 6.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_583_Material_006_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_583_Material_006_0.geometry}
                    material={materials.Material_006}
                  />
                </group>
                <group
                  name="Cube_582"
                  position={[-6, 21.52, -7.018]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_582_Material_006_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_582_Material_006_0.geometry}
                    material={materials.Material_006}
                  />
                </group>
                <group
                  name="Cube_581"
                  position={[6, 21.52, -7.018]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_581_Material_006_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_581_Material_006_0.geometry}
                    material={materials.Material_006}
                  />
                </group>
                <group
                  name="Cube_580"
                  position={[6, 21.52, 6.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_580_Material_006_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_580_Material_006_0.geometry}
                    material={materials.Material_006}
                  />
                </group>
                <group
                  name="Cube_579"
                  position={[6, 13.52, 6.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_579_Material_006_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_579_Material_006_0.geometry}
                    material={materials.Material_006}
                  />
                </group>
                <group
                  name="Cube_578"
                  position={[6, 13.52, -7.018]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_578_Material_006_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_578_Material_006_0.geometry}
                    material={materials.Material_006}
                  />
                </group>
                <group
                  name="Cube_001"
                  position={[-6, 13.52, -7.018]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_001_Material_006_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_001_Material_006_0.geometry}
                    material={materials.Material_006}
                  />
                </group>
                <group
                  name="Cube_000"
                  position={[-6, 13.52, 6.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_000_Material_006_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_000_Material_006_0.geometry}
                    material={materials.Material_006}
                  />
                </group>
                <group
                  name="Cube_577"
                  position={[-6, 5.52, 6.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_577_Material_006_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_577_Material_006_0.geometry}
                    material={materials.Material_006}
                  />
                </group>
                <group
                  name="Cube_576"
                  position={[-6, 5.52, -7.018]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_576_Material_006_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_576_Material_006_0.geometry}
                    material={materials.Material_006}
                  />
                </group>
                <group
                  name="Cube_575"
                  position={[6, 5.52, -7.018]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_575_Material_006_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_575_Material_006_0.geometry}
                    material={materials.Material_006}
                  />
                </group>
                <group
                  name="Cube_574"
                  position={[0, 31.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_574_Material_003_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_574_Material_003_0.geometry}
                    material={materials.Material_003}
                  />
                </group>
                <group
                  name="Cube_573"
                  position={[-2, 31.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_573_Material_003_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_573_Material_003_0.geometry}
                    material={materials.Material_003}
                  />
                </group>
                <group
                  name="Cube_572"
                  position={[-4, 31.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_572_Material_003_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_572_Material_003_0.geometry}
                    material={materials.Material_003}
                  />
                </group>
                <group
                  name="Cube_571"
                  position={[2, 31.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_571_Material_003_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_571_Material_003_0.geometry}
                    material={materials.Material_003}
                  />
                </group>
                <group
                  name="Cube_570"
                  position={[4, 31.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_570_Material_003_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_570_Material_003_0.geometry}
                    material={materials.Material_003}
                  />
                </group>
                <group
                  name="Cube_569"
                  position={[-8, 14.52, 9.982]}
                  rotation={[-Math.PI / 2, 0, -1.571]}
                >
                  <mesh
                    name="Cube_569_Material_004_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_569_Material_004_0.geometry}
                    material={materials.Material_004}
                  />
                </group>
                <group
                  name="Cube_568"
                  position={[-8, 6.52, 9.982]}
                  rotation={[-Math.PI / 2, 0, -1.571]}
                >
                  <mesh
                    name="Cube_568_Material_004_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_568_Material_004_0.geometry}
                    material={materials.Material_004}
                  />
                </group>
                <group
                  name="Cube_567"
                  position={[-8, 22.52, 9.982]}
                  rotation={[-Math.PI / 2, 0, -1.571]}
                >
                  <mesh
                    name="Cube_567_Material_004_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_567_Material_004_0.geometry}
                    material={materials.Material_004}
                  />
                </group>
                <group
                  name="Cube_566"
                  position={[-8, 30.52, 9.982]}
                  rotation={[-Math.PI / 2, 0, -1.571]}
                >
                  <mesh
                    name="Cube_566_Material_004_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_566_Material_004_0.geometry}
                    material={materials.Material_004}
                  />
                </group>
                <group
                  name="Cube_565"
                  position={[8, 30.52, 9.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_565_Material_004_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_565_Material_004_0.geometry}
                    material={materials.Material_004}
                  />
                </group>
                <group
                  name="Cube_564"
                  position={[8, 22.52, 9.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_564_Material_004_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_564_Material_004_0.geometry}
                    material={materials.Material_004}
                  />
                </group>
                <group
                  name="Cube_563"
                  position={[8, 6.52, 9.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_563_Material_004_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_563_Material_004_0.geometry}
                    material={materials.Material_004}
                  />
                </group>
                <group
                  name="Cube_562"
                  position={[8, 14.52, 9.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_562_Material_004_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_562_Material_004_0.geometry}
                    material={materials.Material_004}
                  />
                </group>
                <group
                  name="Cube_561"
                  position={[8, 14.52, -10.018]}
                  rotation={[-Math.PI / 2, 0, 1.571]}
                >
                  <mesh
                    name="Cube_561_Material_004_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_561_Material_004_0.geometry}
                    material={materials.Material_004}
                  />
                </group>
                <group
                  name="Cube_560"
                  position={[8, 6.52, -10.018]}
                  rotation={[-Math.PI / 2, 0, 1.571]}
                >
                  <mesh
                    name="Cube_560_Material_004_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_560_Material_004_0.geometry}
                    material={materials.Material_004}
                  />
                </group>
                <group
                  name="Cube_559"
                  position={[8, 22.52, -10.018]}
                  rotation={[-Math.PI / 2, 0, 1.571]}
                >
                  <mesh
                    name="Cube_559_Material_004_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_559_Material_004_0.geometry}
                    material={materials.Material_004}
                  />
                </group>
                <group
                  name="Cube_558"
                  position={[8, 30.52, -10.018]}
                  rotation={[-Math.PI / 2, 0, 1.571]}
                >
                  <mesh
                    name="Cube_558_Material_004_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_558_Material_004_0.geometry}
                    material={materials.Material_004}
                  />
                </group>
                <group
                  name="Cube_557"
                  position={[-8, 30.52, -10.018]}
                  rotation={[-Math.PI / 2, 0, Math.PI]}
                >
                  <mesh
                    name="Cube_557_Material_004_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_557_Material_004_0.geometry}
                    material={materials.Material_004}
                  />
                </group>
                <group
                  name="Cube_556"
                  position={[-8, 22.52, -10.018]}
                  rotation={[-Math.PI / 2, 0, Math.PI]}
                >
                  <mesh
                    name="Cube_556_Material_004_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_556_Material_004_0.geometry}
                    material={materials.Material_004}
                  />
                </group>
                <group
                  name="Cube_555"
                  position={[-8, 6.52, -10.018]}
                  rotation={[-Math.PI / 2, 0, Math.PI]}
                >
                  <mesh
                    name="Cube_555_Material_004_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_555_Material_004_0.geometry}
                    material={materials.Material_004}
                  />
                </group>
                <group
                  name="Cube_554"
                  position={[-8, 14.52, -10.018]}
                  rotation={[-Math.PI / 2, 0, Math.PI]}
                >
                  <mesh
                    name="Cube_554_Material_004_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_554_Material_004_0.geometry}
                    material={materials.Material_004}
                  />
                </group>
                <group
                  name="Cube_553"
                  position={[0, 19.52, -10.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI]}
                >
                  <mesh
                    name="Cube_553_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_553_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_552"
                  position={[0, 27.52, -10.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI]}
                >
                  <mesh
                    name="Cube_552_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_552_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_551"
                  position={[0, 11.52, -10.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI]}
                >
                  <mesh
                    name="Cube_551_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_551_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_550"
                  position={[0, 3.52, -10.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI]}
                >
                  <mesh
                    name="Cube_550_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_550_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_549"
                  position={[0, 3.52, 9.982]}
                  rotation={[-Math.PI / 2, 0, -Math.PI]}
                >
                  <mesh
                    name="Cube_549_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_549_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_548"
                  position={[0, 11.52, 9.982]}
                  rotation={[-Math.PI / 2, 0, -Math.PI]}
                >
                  <mesh
                    name="Cube_548_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_548_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_547"
                  position={[0, 27.52, 9.982]}
                  rotation={[-Math.PI / 2, 0, -Math.PI]}
                >
                  <mesh
                    name="Cube_547_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_547_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_546"
                  position={[0, 19.52, 9.982]}
                  rotation={[-Math.PI / 2, 0, -Math.PI]}
                >
                  <mesh
                    name="Cube_546_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_546_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_544"
                  position={[-8, 19.52, -0.018]}
                  rotation={[Math.PI / 2, 0, Math.PI / 2]}
                >
                  <mesh
                    name="Cube_544_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_544_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_543"
                  position={[-8, 11.52, -0.018]}
                  rotation={[Math.PI / 2, 0, Math.PI / 2]}
                >
                  <mesh
                    name="Cube_543_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_543_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_542"
                  position={[-8, 27.52, -0.018]}
                  rotation={[Math.PI / 2, 0, Math.PI / 2]}
                >
                  <mesh
                    name="Cube_542_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_542_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_541"
                  position={[-8, 3.52, -0.018]}
                  rotation={[Math.PI / 2, 0, Math.PI / 2]}
                >
                  <mesh
                    name="Cube_541_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_541_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_540"
                  position={[8, 3.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_540_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_540_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_539"
                  position={[8, 27.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_539_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_539_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_538"
                  position={[8, 11.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_538_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_538_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_537"
                  position={[8, 19.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_537_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_537_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_536"
                  position={[7, 1.52, -8.018]}
                  rotation={[Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_536_Material_004_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_536_Material_004_0.geometry}
                    material={materials.Material_004}
                  />
                </group>
                <group
                  name="Cube_535"
                  position={[7, 9.52, -8.018]}
                  rotation={[Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_535_Material_004_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_535_Material_004_0.geometry}
                    material={materials.Material_004}
                  />
                </group>
                <group
                  name="Cube_534"
                  position={[7, 17.52, -8.018]}
                  rotation={[Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_534_Material_004_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_534_Material_004_0.geometry}
                    material={materials.Material_004}
                  />
                </group>
                <group
                  name="Cube_533"
                  position={[7, 25.52, -8.018]}
                  rotation={[Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_533_Material_004_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_533_Material_004_0.geometry}
                    material={materials.Material_004}
                  />
                </group>
                <group
                  name="Cube_532"
                  position={[-7, 25.52, -8.018]}
                  rotation={[-Math.PI / 2, 0, Math.PI]}
                >
                  <mesh
                    name="Cube_532_Material_004_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_532_Material_004_0.geometry}
                    material={materials.Material_004}
                  />
                </group>
                <group
                  name="Cube_531"
                  position={[-7, 17.52, -8.018]}
                  rotation={[-Math.PI / 2, 0, Math.PI]}
                >
                  <mesh
                    name="Cube_531_Material_004_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_531_Material_004_0.geometry}
                    material={materials.Material_004}
                  />
                </group>
                <group
                  name="Cube_530"
                  position={[-7, 9.52, -8.018]}
                  rotation={[-Math.PI / 2, 0, Math.PI]}
                >
                  <mesh
                    name="Cube_530_Material_004_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_530_Material_004_0.geometry}
                    material={materials.Material_004}
                  />
                </group>
                <group
                  name="Cube_529"
                  position={[-7, 1.52, -8.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI]}
                >
                  <mesh
                    name="Cube_529_Material_004_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_529_Material_004_0.geometry}
                    material={materials.Material_004}
                  />
                </group>
                <group
                  name="Cube_528"
                  position={[-7, 1.52, 7.982]}
                  rotation={[Math.PI / 2, 0, -Math.PI]}
                >
                  <mesh
                    name="Cube_528_Material_004_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_528_Material_004_0.geometry}
                    material={materials.Material_004}
                  />
                </group>
                <group
                  name="Cube_527"
                  position={[-7, 9.52, 7.982]}
                  rotation={[Math.PI / 2, 0, -Math.PI]}
                >
                  <mesh
                    name="Cube_527_Material_004_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_527_Material_004_0.geometry}
                    material={materials.Material_004}
                  />
                </group>
                <group
                  name="Cube_526"
                  position={[-7, 17.52, 7.982]}
                  rotation={[Math.PI / 2, 0, -Math.PI]}
                >
                  <mesh
                    name="Cube_526_Material_004_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_526_Material_004_0.geometry}
                    material={materials.Material_004}
                  />
                </group>
                <group
                  name="Cube_525"
                  position={[-7, 25.52, 7.982]}
                  rotation={[Math.PI / 2, 0, -Math.PI]}
                >
                  <mesh
                    name="Cube_525_Material_004_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_525_Material_004_0.geometry}
                    material={materials.Material_004}
                  />
                </group>
                <group
                  name="Cube_524"
                  position={[7, 25.52, 7.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_524_Material_004_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_524_Material_004_0.geometry}
                    material={materials.Material_004}
                  />
                </group>
                <group
                  name="Cube_523"
                  position={[7, 17.52, 7.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_523_Material_004_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_523_Material_004_0.geometry}
                    material={materials.Material_004}
                  />
                </group>
                <group
                  name="Cube_522"
                  position={[7, 9.52, 7.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_522_Material_004_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_522_Material_004_0.geometry}
                    material={materials.Material_004}
                  />
                </group>
                <group
                  name="Cube_521"
                  position={[7, 1.52, 7.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_521_Material_004_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_521_Material_004_0.geometry}
                    material={materials.Material_004}
                  />
                </group>
                <group
                  name="Cube_520"
                  position={[-6, 29.52, 5.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_520_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_520_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_513"
                  position={[-6, 29.52, -6.018]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_513_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_513_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_512"
                  position={[6, 5.52, 6.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_512_Material_006_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_512_Material_006_0.geometry}
                    material={materials.Material_006}
                  />
                </group>
                <group
                  name="Cube_509"
                  position={[6, 29.52, 5.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_509_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_509_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_508"
                  position={[6, 29.52, -6.018]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_508_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_508_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_501"
                  position={[6, 29.52, -8.018]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_501_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_501_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_500"
                  position={[-6, 29.52, -8.018]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_500_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_500_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_003"
                  position={[-6, 29.52, 7.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_003_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_003_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_002"
                  position={[6, 29.52, 7.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_002_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_002_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_491"
                  position={[4, 5.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_491_Material_003_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_491_Material_003_0.geometry}
                    material={materials.Material_003}
                  />
                </group>
                <group
                  name="Cube_490"
                  position={[2, 5.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_490_Material_003_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_490_Material_003_0.geometry}
                    material={materials.Material_003}
                  />
                </group>
                <group
                  name="Cube_489"
                  position={[-4, 5.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_489_Material_003_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_489_Material_003_0.geometry}
                    material={materials.Material_003}
                  />
                </group>
                <group
                  name="Cube_488"
                  position={[-2, 5.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_488_Material_003_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_488_Material_003_0.geometry}
                    material={materials.Material_003}
                  />
                </group>
                <group
                  name="Cube_487"
                  position={[0, 5.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_487_Material_003_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_487_Material_003_0.geometry}
                    material={materials.Material_003}
                  />
                </group>
                <group
                  name="Cube_486"
                  position={[0, 13.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_486_Material_003_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_486_Material_003_0.geometry}
                    material={materials.Material_003}
                  />
                </group>
                <group
                  name="Cube_485"
                  position={[-2, 13.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_485_Material_003_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_485_Material_003_0.geometry}
                    material={materials.Material_003}
                  />
                </group>
                <group
                  name="Cube_484"
                  position={[-4, 13.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_484_Material_003_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_484_Material_003_0.geometry}
                    material={materials.Material_003}
                  />
                </group>
                <group
                  name="Cube_483"
                  position={[2, 13.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_483_Material_003_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_483_Material_003_0.geometry}
                    material={materials.Material_003}
                  />
                </group>
                <group
                  name="Cube_482"
                  position={[4, 13.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_482_Material_003_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_482_Material_003_0.geometry}
                    material={materials.Material_003}
                  />
                </group>
                <group
                  name="Cube_481"
                  position={[4, 21.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_481_Material_003_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_481_Material_003_0.geometry}
                    material={materials.Material_003}
                  />
                </group>
                <group
                  name="Cube_480"
                  position={[2, 21.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_480_Material_003_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_480_Material_003_0.geometry}
                    material={materials.Material_003}
                  />
                </group>
                <group
                  name="Cube_479"
                  position={[-4, 21.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_479_Material_003_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_479_Material_003_0.geometry}
                    material={materials.Material_003}
                  />
                </group>
                <group
                  name="Cube_478"
                  position={[-2, 21.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_478_Material_003_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_478_Material_003_0.geometry}
                    material={materials.Material_003}
                  />
                </group>
                <group
                  name="Cube_477"
                  position={[0, 21.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_477_Material_003_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_477_Material_003_0.geometry}
                    material={materials.Material_003}
                  />
                </group>
                <group
                  name="Cube_476"
                  position={[0, 1.52, 1.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_476_Material_001_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_476_Material_001_0.geometry}
                    material={materials.Material_001}
                  />
                </group>
                <group
                  name="Cube_475"
                  position={[0, 1.52, 3.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_475_Material_001_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_475_Material_001_0.geometry}
                    material={materials.Material_001}
                  />
                </group>
                <group
                  name="Cube_474"
                  position={[0, 1.52, -4.018]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_474_Material_001_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_474_Material_001_0.geometry}
                    material={materials.Material_001}
                  />
                </group>
                <group
                  name="Cube_473"
                  position={[0, 1.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_473_Material_001_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_473_Material_001_0.geometry}
                    material={materials.Material_001}
                  />
                </group>
                <group
                  name="Cube_472"
                  position={[0, 1.52, -2.018]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_472_Material_001_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_472_Material_001_0.geometry}
                    material={materials.Material_001}
                  />
                </group>
                <group
                  name="Cube_469"
                  position={[0, 9.52, -4.018]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_469_Material_001_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_469_Material_001_0.geometry}
                    material={materials.Material_001}
                  />
                </group>
                <group
                  name="Cube_468"
                  position={[0, 9.52, 3.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_468_Material_001_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_468_Material_001_0.geometry}
                    material={materials.Material_001}
                  />
                </group>
                <group
                  name="Cube_465"
                  position={[0, 17.52, 3.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_465_Material_001_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_465_Material_001_0.geometry}
                    material={materials.Material_001}
                  />
                </group>
                <group
                  name="Cube_013"
                  position={[0, 17.52, -4.018]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_013_Material_001_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_013_Material_001_0.geometry}
                    material={materials.Material_001}
                  />
                </group>
                <group
                  name="Cube_462"
                  position={[0, 25.52, -4.018]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_462_Material_001_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_462_Material_001_0.geometry}
                    material={materials.Material_001}
                  />
                </group>
                <group
                  name="Cube_460"
                  position={[0, 25.52, 3.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_460_Material_001_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_460_Material_001_0.geometry}
                    material={materials.Material_001}
                  />
                </group>
                <group
                  name="Cube_459"
                  position={[4, 3.52, -8.018]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_459_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_459_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_454"
                  position={[4, 11.52, -8.018]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_454_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_454_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_453"
                  position={[4, 19.52, -8.018]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_453_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_453_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_448"
                  position={[4, 27.52, -8.018]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_448_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_448_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_447"
                  position={[2, 27.52, -8.018]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_447_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_447_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_442"
                  position={[2, 19.52, -8.018]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_442_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_442_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_441"
                  position={[2, 11.52, -8.018]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_441_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_441_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_436"
                  position={[2, 3.52, -8.018]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_436_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_436_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_435"
                  position={[-2, 3.52, -8.018]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_435_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_435_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_430"
                  position={[-2, 11.52, -8.018]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_430_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_430_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_429"
                  position={[-2, 19.52, -8.018]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_429_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_429_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_424"
                  position={[-2, 27.52, -8.018]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_424_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_424_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_423"
                  position={[0, 27.52, -8.018]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_423_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_423_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_421"
                  position={[0, 29.52, -8.018]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_421_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_421_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_419"
                  position={[0, 23.52, -8.018]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_419_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_419_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_418"
                  position={[0, 19.52, -8.018]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_418_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_418_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_417"
                  position={[0, 11.52, -8.018]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_417_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_417_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_416"
                  position={[0, 15.52, -8.018]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_416_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_416_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_413"
                  position={[0, 7.52, -8.018]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_413_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_413_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_412"
                  position={[0, 3.52, -8.018]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_412_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_412_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_411"
                  position={[-4, 27.52, -8.018]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_411_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_411_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_406"
                  position={[-4, 19.52, -8.018]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_406_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_406_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_405"
                  position={[0, 9.52, -8.018]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_405_Material_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_405_Material_0.geometry}
                    material={materials.Material}
                  />
                </group>
                <group
                  name="Cube_404"
                  position={[-4, 11.52, -8.018]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_404_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_404_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_399"
                  position={[-4, 3.52, -8.018]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_399_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_399_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_398"
                  position={[0, 17.52, -8.018]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_398_Material_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_398_Material_0.geometry}
                    material={materials.Material}
                  />
                </group>
                <group
                  name="Cube_397"
                  position={[0, 1.52, -8.018]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_397_Material_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_397_Material_0.geometry}
                    material={materials.Material}
                  />
                </group>
                <group
                  name="Cube_396"
                  position={[0, 25.52, -8.018]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_396_Material_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_396_Material_0.geometry}
                    material={materials.Material}
                  />
                </group>
                <group
                  name="Cube_388"
                  position={[6, 3.52, -4.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_388_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_388_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_383"
                  position={[6, 11.52, -4.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_383_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_383_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_381"
                  position={[6, 19.52, -4.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_381_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_381_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_378"
                  position={[6, 29.52, -4.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_378_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_378_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_377"
                  position={[6, 31.52, -3.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_377_Material_007_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_377_Material_007_0.geometry}
                    material={materials.Material_007}
                  />
                </group>
                <group
                  name="Cube_376"
                  position={[6, 27.52, -4.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_376_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_376_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_375"
                  position={[6, 3.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_375_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_375_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_374"
                  position={[6, 7.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_374_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_374_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_371"
                  position={[6, 15.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_371_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_371_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_370"
                  position={[6, 11.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_370_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_370_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_369"
                  position={[6, 19.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_369_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_369_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_368"
                  position={[6, 23.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_368_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_368_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_365"
                  position={[6, 31.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_365_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_365_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_364"
                  position={[6, 27.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_364_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_364_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_363"
                  position={[6, 27.52, -2.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_363_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_363_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_359"
                  position={[6, 23.52, -2.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_359_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_359_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_358"
                  position={[6, 19.52, -2.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_358_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_358_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_357"
                  position={[6, 11.52, -2.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_357_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_357_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_356"
                  position={[6, 15.52, -2.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_356_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_356_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_353"
                  position={[6, 7.52, -2.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_353_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_353_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_352"
                  position={[6, 3.52, -2.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_352_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_352_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_351"
                  position={[6, 3.52, 1.982]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_351_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_351_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_350"
                  position={[6, 7.52, 1.982]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_350_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_350_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_347"
                  position={[6, 15.52, 1.982]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_347_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_347_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_346"
                  position={[6, 11.52, 1.982]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_346_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_346_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_345"
                  position={[6, 19.52, 1.982]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_345_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_345_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_344"
                  position={[6, 23.52, 1.982]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_344_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_344_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_340"
                  position={[6, 27.52, 1.982]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_340_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_340_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_339"
                  position={[6, 27.52, 3.982]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_339_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_339_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_337"
                  position={[6, 29.52, 3.982]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_337_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_337_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_334"
                  position={[6, 19.52, 3.982]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_334_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_334_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_333"
                  position={[6, 11.52, 3.982]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_333_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_333_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_328"
                  position={[6, 3.52, 3.982]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_328_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_328_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_327"
                  position={[-6, 3.52, 3.982]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_327_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_327_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_062"
                  position={[-6, 11.52, 3.982]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_062_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_062_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_061"
                  position={[-6, 19.52, 3.982]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_061_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_061_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_058"
                  position={[-6, 29.52, 3.982]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_058_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_058_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_056"
                  position={[-6, 27.52, 3.982]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_056_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_056_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_055"
                  position={[-6, 27.52, 1.982]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_055_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_055_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_051"
                  position={[-6, 23.52, 1.982]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_051_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_051_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_050"
                  position={[-6, 19.52, 1.982]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_050_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_050_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_049"
                  position={[-6, 11.52, 1.982]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_049_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_049_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_048"
                  position={[-6, 15.52, 1.982]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_048_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_048_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_045"
                  position={[-6, 7.52, 1.982]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_045_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_045_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_044"
                  position={[-6, 3.52, 1.982]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_044_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_044_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_043"
                  position={[-6, 3.52, -2.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_043_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_043_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_042"
                  position={[-6, 7.52, -2.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_042_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_042_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_039"
                  position={[-6, 15.52, -2.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_039_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_039_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_038"
                  position={[-6, 11.52, -2.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_038_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_038_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_037"
                  position={[-6, 19.52, -2.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_037_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_037_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_036"
                  position={[-6, 23.52, -2.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_036_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_036_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_032"
                  position={[-6, 27.52, -2.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_032_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_032_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_031"
                  position={[-6, 27.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_031_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_031_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_030"
                  position={[-6, 31.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_030_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_030_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_027"
                  position={[-6, 23.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_027_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_027_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_026"
                  position={[-6, 19.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_026_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_026_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_025"
                  position={[-6, 11.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_025_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_025_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_024"
                  position={[-6, 15.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_024_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_024_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_021"
                  position={[-6, 7.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_021_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_021_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_020"
                  position={[-6, 3.52, -0.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_020_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_020_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_019"
                  position={[-6, 27.52, -4.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_019_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_019_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_017"
                  position={[-6, 29.52, -4.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_017_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_017_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_014"
                  position={[-6, 19.52, -4.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_014_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_014_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_012"
                  position={[-6, 11.52, -4.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_012_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_012_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_007"
                  position={[-6, 3.52, -4.018]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                >
                  <mesh
                    name="Cube_007_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_007_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_323"
                  position={[0, 25.52, 7.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_323_Material_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_323_Material_0.geometry}
                    material={materials.Material}
                  />
                </group>
                <group
                  name="Cube_322"
                  position={[0, 1.52, 7.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_322_Material_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_322_Material_0.geometry}
                    material={materials.Material}
                  />
                </group>
                <group
                  name="Cube_321"
                  position={[0, 17.52, 7.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_321_Material_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_321_Material_0.geometry}
                    material={materials.Material}
                  />
                </group>
                <group
                  name="Cube_222"
                  position={[-4, 3.52, 7.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_222_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_222_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_217"
                  position={[-4, 11.52, 7.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_217_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_217_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_216"
                  position={[0, 9.52, 7.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_216_Material_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_216_Material_0.geometry}
                    material={materials.Material}
                  />
                </group>
                <group
                  name="Cube_214"
                  position={[-4, 19.52, 7.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_214_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_214_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_209"
                  position={[-4, 27.52, 7.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_209_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_209_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_126"
                  position={[0, 3.52, 7.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_126_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_126_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_125"
                  position={[0, 7.52, 7.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_125_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_125_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_122"
                  position={[0, 15.52, 7.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_122_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_122_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_121"
                  position={[0, 11.52, 7.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_121_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_121_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_118"
                  position={[0, 19.52, 7.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_118_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_118_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_117"
                  position={[0, 23.52, 7.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_117_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_117_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_115"
                  position={[0, 29.52, 7.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_115_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_115_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_113"
                  position={[0, 27.52, 7.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_113_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_113_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_110"
                  position={[-2, 27.52, 7.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_110_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_110_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_105"
                  position={[-2, 19.52, 7.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_105_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_105_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_102"
                  position={[-2, 11.52, 7.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_102_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_102_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_097"
                  position={[-2, 3.52, 7.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_097_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_097_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_094"
                  position={[2, 3.52, 7.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_094_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_094_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_089"
                  position={[2, 11.52, 7.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_089_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_089_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_086"
                  position={[2, 19.52, 7.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_086_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_086_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_081"
                  position={[2, 27.52, 7.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_081_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_081_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_078"
                  position={[4, 27.52, 7.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_078_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_078_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_073"
                  position={[4, 19.52, 7.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_073_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_073_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_070"
                  position={[4, 11.52, 7.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_070_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_070_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
                <group
                  name="Cube_065"
                  position={[4, 3.52, 7.982]}
                  rotation={[-Math.PI / 2, 0, 0]}
                >
                  <mesh
                    name="Cube_065_unnamed_0"
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube_065_unnamed_0.geometry}
                    material={materials.unnamed}
                  />
                </group>
              </group>
            </group>
          </group>
        </group>
      </group>
    </group>
  );
}

export default Bullet